import React, { Component } from 'react';
import _ from 'lodash';

import ProfileIndustryCard from './ProfileIndustryCard';
import SectionTitle from './SectionTitle';
import AddSkill from './AddSkill';
import SkillsChips from './SkillsChips';
import EmailShareCard from './EmailShareCard';
import EmptyState from './EmptyState';
import ApplyCard from './ApplyCard';

import { Card, CardContent } from 'material-ui';

import Fade from 'material-ui/transitions/Fade';

const style = {
	feed: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	skillChip: {
		margin: '3px 5px'
	}
};

export default class Feed extends Component {
	renderUserFeed = () => {
		let html = [];
		html.push(
			<SectionTitle key="update_your_skills" title="Update Your Skills" />
		);
		html.push(
			<Fade key="user_feed_card" in={true}>
				<Card className="card">
					<CardContent className="skillsChipsContent">
						{!_.isEmpty(this.props.skills) && (
							<SkillsChips skills={this.props.skills} />
						)}
					</CardContent>
					<CardContent>
						<AddSkill uid={this.props.uid} />
					</CardContent>
				</Card>
			</Fade>
		);
		return html;
	};

	renderQuickApply = () => {
		let html = [];
		Object.keys(this.props.invited)
			.map(oid => this.props.invited[oid])
			.filter(invite => !invite.archived)
			.filter(invite => !!this.props.jobs[invite.jid])
			.map(invite => {
				return { ...invite, ...this.props.jobs[invite.jid] };
			})
			.filter(job => job.status === 'published')
			.forEach((job, i) => {
				console.log(job);
				html.push(
					<Fade in={true} timeout={{ enter: i * 100 }}>
						<SectionTitle
							key={`quick_share_section_title_${job.oid}_${i}`}
							title={`Quick Apply ${job.title} @ ${job.company}`}
						/>
					</Fade>
				);
				html.push(
					<Fade in={true} timeout={{ enter: i * 100 }}>
						<ApplyCard
							key={`share_card_${job.oid}_${i}`}
							oid={job.oid}
							job={job}
							user={this.props.user}
						/>
					</Fade>
				);
				// html.push(
				// 	<Fade in={true} timeout={{ enter: i * 100 }}>
				// 		<SectionTitle
				// 			key={`quick_apply_section_title_${job.oid}_${i}`}
				// 			title={`Quick Share ${job.title} @ ${job.company}`}
				// 		/>
				// 	</Fade>
				// );
				// html.push(
				// 	<Fade in={true} timeout={{ enter: i * 100 }}>
				// 		<EmailShareCard
				// 			key={`apply_card_${job.oid}_${i}`}
				// 			oid={job.oid}
				// 			jid={job.jid}
				// 			uid={this.props.uid}
				// 		/>
				// 	</Fade>
				// );
			});
		return html;
	};

	renderAdminFeed = () => {
		let html = [];
		html.push(<SectionTitle key="create_ad_key" title="Create Ad" />);
		html.push(
			<EmptyState
				key="create_ad"
				subject={'Create Ad'}
				message={
					'Post a Job Ad today to start sharing and receiving applicants.'
				}
				btnDestination={'/AddJob'}
				btnMsg={'Add a Job'}
			/>
		);
		Object.keys(this.props.myJobs)
			.map(jid => this.props.myJobs[jid])
			.filter(myJob => !myJob.archived)
			.filter(myJob => !!this.props.jobs[myJob.jid])
			.map(myJob => {
				return { ...myJob, ...this.props.jobs[myJob.jid] };
			})
			.forEach((job, i) => {
				html.push(
					<SectionTitle
						key={`section_title_${job.oid}_${i}`}
						title={`Quick Share ${job.title} @ ${job.company}`}
					/>
				);
				html.push(
					<EmailShareCard
						key={`share_card_${job.oid}_${i}`}
						oid={job.oid}
						jid={job.jid}
						uid={this.props.uid}
					/>
				);
			});
		return html;
	};

	render() {
		return (
			<div style={style.feed}>
				{!_.isEmpty(this.props.profile) &&
					(!this.props.profile.industry || !this.props.profile.function) && (
						<SectionTitle
							key="complete_your_profile"
							title="Complete Your Profile"
						/>
					)}
				{!_.isEmpty(this.props.profile) &&
					(!this.props.profile.industry || !this.props.profile.function) && (
						<ProfileIndustryCard
							key="profile_industry_card"
							profile={this.props.profile}
						/>
					)}

				{!this.props.adminLoading && !this.props.admin && this.renderUserFeed()}

				{!this.props.adminLoading &&
					!this.props.admin &&
					this.renderQuickApply()}

				{!this.props.adminLoading &&
					!!this.props.admin &&
					!this.props.myJobsLoading &&
					this.renderAdminFeed()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Feed.js